import { createSlice } from '@reduxjs/toolkit';
import { getBatchDefinitions } from 'ducks/batch-definitions/operators';
import { normalizeBatchDefinitions } from 'ducks/batch-definitions/utils';
import { Slices } from 'ducks/slices';
import { BatchDefinition } from 'ducks/types/store-types';

export type BatchDefinitionsState = BatchDefinition[];

const initialState: BatchDefinitionsState = [];

const batchDefinitionsSlice = createSlice({
  name: Slices.BATCH_DEFINITIONS,
  initialState,
  reducers: {
    clearBatchDefinitions: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchDefinitions.pending, () => {
        return initialState;
      })
      .addCase(getBatchDefinitions.fulfilled, (_, { payload }) => {
        return normalizeBatchDefinitions(payload);
      })
      .addCase(getBatchDefinitions.rejected, () => {
        return initialState;
      });
  },
});

export const { clearBatchDefinitions } = batchDefinitionsSlice.actions;

export default batchDefinitionsSlice.reducer;
